/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import { h, Fragment } from 'preact';
import { Swiper, SwiperSlide } from 'swiper/react';
// eslint-disable-next-line import/no-unresolved
import SwiperCore, { Pagination } from 'swiper/core';
import clsx from 'clsx';
import { useEffect } from 'preact/hooks';
import VimeoPlayer from '../utils/vimeoPlayer';
import Image from '../utils/image';
import VideoSrcPlayer from '../utils/videoSrcPlayer';

SwiperCore.use([Pagination]);

const pagination = {
  el: '.custom-pagination',
  clickable: true,
  type: 'progressbar',
};

const ProductGalleryMedia = ({ media, setInitZoom, isGift }) => {
  const mediaType = media.node.mediaContentType;
  // eslint-disable-next-line no-unused-vars
  if (mediaType === 'IMAGE') {
    return (
      <button
        className={`col-span-1 bg-grey-200 block w-full h-full ${
          isGift ? 'laptop:col-span-2 laptop:pt-[80%]' : 'laptop:col-span-1'
        } cursor-pointer relative pt-[125%]`}
        onClick={() => setInitZoom(true)}
      >
        <Image
          {...media.node.image}
          className="absolute w-full h-full top-0 left-0 object-contain"
          srcWidths={{
            sm: 640,
            md: 768,
            lg: 300,
            xl: 560,
            '2xl': 560,
          }}
          loading="eager"
        />
      </button>
    );
  }
  if (mediaType === 'EXTERNAL_VIDEO' && media.node.host === 'VIMEO') {
    return (
      <div
        className={`col-span-1 ${
          isGift ? 'laptop:col-span-2' : 'laptop:col-span-1'
        } cursor-pointer`}
      >
        <VimeoPlayer
          url={media.node.embedUrl}
          id={media.node.id}
          autoplay={true}
          className={'pt-[125%] video-absolute'}
          loop={true}
        />
      </div>
    );
  }
  if (mediaType === 'VIDEO') {
    return (
      <div
        className={clsx(
          'col-span-1 cursor-pointer',
          isGift ? 'laptop:col-span-2' : 'laptop:col-span-1',
        )}
      >
        <VideoSrcPlayer sources={media.node.sources} />
      </div>
    );
  }
};

const ProductGallery = ({ setInitZoom, isTablet, currentProduct, isGift }) => {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        setInitZoom(false);
      }
    };

    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [setInitZoom]);

  return (
    <div
      className={`col-span-12 laptop:col-span-7 grid-cols-1 ${
        !isGift ? 'laptop:grid-cols-2' : 'bg-grey-200'
      } grid gap-[5px]`}
    >
      {!isTablet &&
        currentProduct?.media?.edges?.map((media, index) => {
          if (index !== 0 || isGift) {
            if (index === 3 && currentProduct?.mediaHorizontalImage?.value) {
              return (
                <Fragment key={media.node.id}>
                  <button
                    className={`col-span-1 bg-grey-200 block w-full h-full ${'laptop:col-span-2'} cursor-pointer relative pt-[60%]`}
                    onClick={() => setInitZoom(true)}
                  >
                    <Image
                      src={currentProduct?.mediaHorizontalImage?.value}
                      className="absolute w-full h-full top-0 left-0 object-cover"
                      srcWidths={{
                        sm: 640,
                        md: 768,
                        lg: 600,
                        xl: 900,
                        '2xl': 900,
                      }}
                      loading="eager"
                    />
                    <p className="heading-2 absolute z-[1] left-[50%] bottom-[8%] -translate-x-1/2 text-center w-[90%] text-[2rem]">
                      {currentProduct?.title}
                    </p>
                  </button>
                  <ProductGalleryMedia
                    media={media}
                    setInitZoom={setInitZoom}
                    key={media.node.id}
                    currentProduct={currentProduct}
                    isGift={isGift}
                    isHorizontal={false}
                  />
                </Fragment>
              );
            }
            return (
              <ProductGalleryMedia
                media={media}
                setInitZoom={setInitZoom}
                key={media.node.id}
                currentProduct={currentProduct}
                isGift={isGift}
                isHorizontal={false}
              />
            );
          }
        })}
      {isTablet && (
        <div className="max-w-full relative">
          <Swiper
            modules={[Pagination]}
            slidesPerView={1}
            pagination={pagination}
          >
            {currentProduct?.media?.edges?.map((media, index) => {
              if (index !== 0 || isGift) {
                if (
                  index === 3 &&
                  currentProduct?.mediaHorizontalImageMobile?.value
                ) {
                  return (
                    <Fragment key={media.node.id}>
                      <SwiperSlide>
                        <button
                          className={`col-span-1 block w-full h-full ${
                            isGift
                              ? 'laptop:col-span-2 laptop:pt-[80%]'
                              : 'laptop:col-span-1'
                          } cursor-pointer relative pt-[125%] bg-grey-200`}
                          onClick={() => setInitZoom(true)}
                        >
                          <Image
                            src={
                              currentProduct?.mediaHorizontalImageMobile?.value
                            }
                            className="absolute w-full h-full top-0 left-0 object-contain"
                            srcWidths={{
                              sm: 640,
                              md: 768,
                              lg: 300,
                              xl: 560,
                              '2xl': 560,
                            }}
                            loading="eager"
                          />
                        </button>
                      </SwiperSlide>
                      <SwiperSlide key={media.node.id}>
                        <ProductGalleryMedia
                          media={media}
                          setInitZoom={setInitZoom}
                          currentProduct={currentProduct}
                        />
                      </SwiperSlide>
                    </Fragment>
                  );
                }
                return (
                  <SwiperSlide key={media.node.id}>
                    <ProductGalleryMedia
                      media={media}
                      setInitZoom={setInitZoom}
                      currentProduct={currentProduct}
                    />
                  </SwiperSlide>
                );
              }
            })}
          </Swiper>
          <div className="custom-pagination !absolute !bottom-0 !top-auto !left-0 !w-full !z-10 !bg-grey-400" />
        </div>
      )}
    </div>
  );
};

export default ProductGallery;
